<template>
    <div
    :class="{'chatbot-combo': true, 'chatbot-combo--visible': showChatModal, 'chatbot-combo--hidden': !isFullyVisible }" @transitionend="handleTransitionEnd">
        <div class="chatbot-combo__combo-fixed">
            <div class="chatbot-combo__chat-greeting" v-if="currentChatMode == null">
                <div class="chatbot-combo__message">
                    <span class="chatbot-combo__greeting-title" v-html="$t('ChatBotCombo.greeting_title')"></span>
                    <p v-html="$t('ChatBotCombo.greeting_paragraph')"></p>
                </div>

                <div @click="changeChatMode('eva')" class="chatbot-combo__chat-button chat-button--eva" role="button">
                    <img src="@/assets/images/chatbot/eva_simple.png" :alt="$t('ChatBotCombo.eva_img_alt_text')">
                    <h4 v-html="$t('ChatBotCombo.eva_button_header')"></h4>
                    <p v-html="$t('ChatBotCombo.eva_button_paragraph')"></p>
                </div>
                <div @click="changeChatMode('hubspot')" :class="['chatbot-combo__chat-button chat-button--support', {'disabled': !areStatisticsCookiesEnabled }]" role="button">
                    <img src="@/assets/images/chatbot/hubspot/button.svg" alt="Support">
                    <div class="chatbot-combo__title">
                        <h4 v-html="$t('ChatBotCombo.support_chat_button_header')"></h4>
                        <span class="chatbot-combo__unread-conversations-count" v-if="unreadConversationsCount > 0">{{ unreadConversationsCount }}</span>
                    </div>
                    <p v-html="$t('ChatBotCombo.support_chat_button_paragraph')"></p>
                </div>
                <div v-if="!this.areStatisticsCookiesEnabled" class="chatbot-combo__chat-button chat-button--needs-cookies" role="button">
                    <span class="icon-notification" alt="Chat needs cookies"></span>
                    <h4 v-html="$t('ChatBotCombo.need_cookies_button_header')"></h4>
                    <p v-html="$t('ChatBotCombo.need_cookies_button_paragraph')"></p>
                    <a class="chatbot-combo__change-cookies-button" href="javascript: Cookiebot.show()" v-html="$t('ChatBotCombo.need_cookies_change_settings')"></a>
                </div>

                <button @click="hideChatModal()" class="chatbot-combo__close-button icon-cancel"
                        aria-label="Close chat"></button>
            </div>
            <div :class="{'hidden': !evaVisible}">
                <EvaChatBot />
            </div>
            <div :class="{'hidden': !hubspotVisible}">
                <HubSpotChat @hide-chat-requested="hideChatModal" wrapper_id="hubspot-chat-combo"/>
            </div>
        </div>
    </div>
</template>

<script>
    import EvaChatBot from 'components/chatbot/assistant/EvaChatBot'
    import HubSpotChat from 'components/chatbot/customer_support/HubSpotChat'
    import { mapGetters } from 'vuex'

    export default {
        name: 'ChatComboModal',
        components: { HubSpotChat, EvaChatBot },
        data: () => ({
            isFullyVisible: false
        }),
        computed: {
            ...mapGetters({
                showChatModal: 'ChatBotCombo/getShowChatModal',
                currentChatMode: 'ChatBotCombo/getCurrentChatMode',
                areStatisticsCookiesEnabled: 'Hubspot/hubspotChatIsAvailable',
                unreadConversationsCount: 'Hubspot/unreadConversationCount'
            }),
            evaVisible () {
                return this.currentChatMode === 'eva'
            },
            hubspotVisible () {
                return this.currentChatMode === 'hubspot'
            }
        },
        methods: {
            hideChatModal () {
                this.$store.dispatch('ChatBotCombo/setShowChatModal', false)
            },
            changeChatMode (mode) {
                if (mode === 'hubspot' && !this.areStatisticsCookiesEnabled) {
                    return
                }
                if (mode === 'hubspot') {
                    this.$store.dispatch('Hubspot/UnreadConversationCountChanged', 0)
                }
                this.$store.dispatch('ChatBotCombo/setCurrentChatMode', mode)
            },
            handleShowChatbotComboModal (showchatBotCombotModal) {
                this.showChatModal = !this.showChatModal
                if (this.showChatModal) {
                    this.isFullyVisible = true
                }
                if (!showchatBotCombotModal) {
                    document.body.classList.remove('eva-chatbot-open-mobile')
                } else if (showchatBotCombotModal && this.isMobileView) {
                    document.body.classList.add('eva-chatbot-open-mobile')
                }
            },
            handleTransitionEnd (event) {
                if (event.propertyName === 'bottom' && !this.showChatModal) {
                    this.isFullyVisible = false
                }
            }
        },
        watch: {
            showChatModal (newValue) {
                this.handleShowChatbotComboModal(newValue)
            },
            isMobileView () {
                this.handleShowChatbotComboModal(this.showChatModal)
            },
            immediate: true
        }
    }
</script>

<style scoped lang="scss">

.chatbot-combo {
    position: fixed;
    right: 20px;
    bottom: calc(-100vh - 600px);
    width: 500px;
    height: 746px;
    z-index: 10022;
    display: flex;
    justify-content: stretch;
    align-items: stretch;
    align-content: stretch;
    transition: bottom 0.3s ease-in-out;

    [class="mobile_sm"] & {
        width: 100%;
        height: 100%;
        right: 0;
    }

    &.chatbot-combo--visible {
        display: flex;
        bottom: 20px;
        height: min(690px, 100vh - 110px);

        [class="mobile_sm"] & {
            bottom: 0;
            height: 100%;
        }
    }

    &.chatbot-combo--hidden {
        opacity: 0;
        z-index: -1;
    }

    &__combo-fixed {
        position: relative;
        flex: 1;
        width: 100%;
        max-width: 600px;
        background-color: $white;
        border-radius: 10px;
        box-shadow: 2px 2px 8px 0 #00000059;
        overflow: hidden;
        display: flex;
        justify-content: stretch;
        align-content: stretch;
        align-items: stretch;

        [class="mobile_sm"] & {
            border-radius: 0;
        }

        & > * {
            flex: 1;
        }
    }

    &__chat-greeting {
        background: url("~@/assets/images/chatbot/combo_greeting_bg.png") no-repeat center top;
        background-size: 100% auto;
        padding: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: stretch;
        gap: 20px;
    }

    &__chat-button {
        border: 1px solid $alto;
        border-radius: 10px;
        box-shadow: 0 0 10px 0 #0000001A;
        display: grid;
        grid-template-columns: 40px 1fr;
        gap: 15px;
        padding: 15px;
        cursor: pointer;

        &.chat-button--eva {
            &:hover {
                background-color: $champagne;
            }
        }

        &.chat-button--support {

            &.disabled {
                cursor: default;
                opacity: 0.5;
            }

            &:hover {
                background-color: $pattens_blue;
            }
        }

        &.chat-button--needs-cookies {
            cursor: default !important;

            .icon-notification {
                cursor: default !important;
                color: $chestnut;
                padding: 5px;
                font-size: 3.2rem;
                grid-row-start: 1;
                grid-row-end: 3;
            }
        }

        img {
            width: 40px;
            grid-row-start: 1;
            grid-row-end: 3;
        }

        h4, p {
            grid-column: 2;
        }

        h4 {
            grid-row: 1;
        }

        a {
            grid-column: 2;
            grid-row: 0;
        }
    }

    &__close-button {
        appearance: none;
        background: none;
        position: absolute;
        right: 15px;
        top: 20px;
        border: none;
        font-size: 2.3rem;

        [class="mobile_sm"] & {
            top: 35px;
        }
    }

    .hidden {
        display: none;
    }

    &__change-cookies-button {
        font-family: Nunito-Bold, sans-serif;
        cursor: pointer;
        color: $orange;
        text-decoration: underline;
    }

    &__greeting-title {
        font-size: 2.6rem;
        font-family: Quicksand-Bold, sans-serif;
    }

    &__message {
        margin: 15px;
        font-size: 1.8rem;

        p {
            margin: 15px 0 0 0;
        }
    }

    &__unread-conversations-count {
        box-shadow: 0 0 6px 0 #00000080;
        width: 20px;
        height: 20px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        font-size: 1.2rem;
        color: $white;
        background: $metallic_red;
        border-radius: 50%;
    }

    &__title {
        gap: 8px;
        display: flex;
        flex-direction: row;
    }
}

</style>
